import {createI18n} from "vue-i18n";

const numberFormats = {
  en: {
    currency: {
      maximumSignificantDigits: 3,
      compactDisplay: 'short',
      notation: 'compact',
      style: 'currency',
      currency: 'USD',
      currencyDisplay: 'narrowSymbol',
      unitDisplay: 'narrow',
      rounding: 'expand',
    },
  },
  de: {
    currency: {
      maximumSignificantDigits: 3,
      compactDisplay: 'short',
      notation: 'compact',
      style: 'currency',
      currency: 'EUR',
      currencyDisplay: 'narrowSymbol',
      unitDisplay: 'narrow',
      rounding: 'expand',
    },
  },
};

const i18n = createI18n({
  missingWarn: false,
  silentTranslationWarn: true,
  // @ts-ignore
  numberFormats,
});

const translator = i18n.global;
const currency = i18n.global;

export {translator, currency};

export {i18n};
